import React, { useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Step } from 'semantic-ui-react';
import additionalMessages from '../../messages';
import { getSampleSitesCsvUrl } from './siteImportConfig';

export type SiteCSVWizardPropsType = {
  step: number;
  groupKind: string;
};

function SiteCSVWizard({ step, groupKind }: SiteCSVWizardPropsType) {
  const { formatMessage } = useIntl();
  const sampleSitesCsvUrl = getSampleSitesCsvUrl(groupKind);

  const steps = useMemo(
    () => [
      {
        key: 'choose-file',
        title: formatMessage(additionalMessages.chooseFile),
        description: (
          <FormattedMessage
            {...additionalMessages.chooseFileDescr}
            values={{
              a: (msg: string) => (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={sampleSitesCsvUrl}
                >
                  {msg}
                </a>
              ),
            }}
          />
        ),
      },
      {
        key: 'verify-file',
        title: formatMessage(additionalMessages.verifyFile),
        description: formatMessage(additionalMessages.verifyFileDescription),
      },
    ],
    [formatMessage, sampleSitesCsvUrl]
  );

  return (
    <Step.Group widths={steps.length} ordered>
      {steps.map((wizardStep, index) => (
        <Step
          key={wizardStep.key}
          completed={step > index + 1}
          active={step === index + 1}
        >
          <Step.Content>
            <Step.Title>{wizardStep.title}</Step.Title>
            <Step.Description>{wizardStep.description}</Step.Description>
          </Step.Content>
        </Step>
      ))}
    </Step.Group>
  );
}

export default SiteCSVWizard;
